/**
 * Prelazak na sledeću stranu spiska.
 *
 * Stoji i iznad i ispod tabele. Samo iznad nije dovoljno: kad čitalac prođe pedeset redova,
 * dugme ostane van vidokruga, pa spisak deluje kao da nema nastavka. Samo ispod nije dovoljno
 * jer se tada ne vidi ni koliko redova uopšte ima dok se ne skroluje do kraja.
 */
import { useTranslation } from "react-i18next";
import { Spinner } from "./Loading";

export function Pager({
  page,
  size,
  total,
  busy,
  onPage,
}: {
  page: number;
  size: number;
  total: number;
  busy?: boolean;
  onPage: (p: number) => void;
}) {
  const { t } = useTranslation();
  if (total <= size) return null;
  const poslednja = Math.ceil(total / size) - 1;
  return (
    <div style={traka}>
      <span style={{ color: "var(--ink-3)", fontSize: 12.5 }}>
        {t("common.pager.range", {
          from: page * size + 1,
          to: Math.min((page + 1) * size, total),
          total,
          defaultValue: "{{from}}–{{to}} od {{total}}",
        })}
        {busy && <Spinner size={13} style={{ marginLeft: 8, verticalAlign: "-2px" }} />}
      </span>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <button type="button" className="btn sm" disabled={page === 0 || busy}
                onClick={() => onPage(Math.max(0, page - 1))}>
          {t("common.previous", "Prethodna")}
        </button>
        <span style={{ color: "var(--ink-3)", fontSize: 12.5, fontVariantNumeric: "tabular-nums" }}>
          {t("common.pager.page", { page: page + 1, pages: poslednja + 1, defaultValue: "{{page}}/{{pages}}" })}
        </span>
        <button type="button" className="btn sm" disabled={page >= poslednja || busy}
                onClick={() => onPage(page + 1)}>
          {t("common.next", "Sledeća")}
        </button>
      </div>
    </div>
  );
}

/**
 * Traka se drži na okupu i stoji po sredini, umesto da se razvuče na ivice.
 *
 * Sa `space-between` na širokom ekranu podatak o opsegu odleti skroz levo, dugmad skroz desno, a
 * između ostane pola ekrana praznine koja ništa ne znači. Uz to plutajuće dugme za razgovor stoji
 * u donjem desnom uglu i pokrivalo je „Sledeća".
 */
const traka: React.CSSProperties = {
  display: "flex", alignItems: "center", justifyContent: "center",
  gap: 24, padding: "12px 0", flexWrap: "wrap",
};
